import { AgencyId, Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { adminAgentPreviewsQueryKey } from "../agency.keys";

export const useAdminFetchAgentPreviewsForAgency = (
	id?: AgencyId | "",
	includeInactive?: boolean,
) => {
	const { get } = useRequest();
	const { data, error, isLoading } = useQuery({
		queryKey: adminAgentPreviewsQueryKey(id || undefined),
		queryFn: async () =>
			await get<Dtos.Agent.Preview.Get.Response[]>(`/v2/admin/agencies/${id}/agents`),
		enabled: !!id,
		staleTime: 1000 * 60 * 60 * 24 * 7,
		gcTime: 1000 * 60 * 60 * 24 * 7,
	});

	return {
		agentPreviews: includeInactive ? data : data?.filter((agent) => !agent.invitationPending),
		agentPreviewsError: error,
		agentPreviewsLoading: isLoading,
	};
};
